// Resolve the signed-in user's Clerk username for building /decks/:owner/:slug
// URLs. Returns null briefly during Clerk initialization — callers must
// guard with optional chaining before navigating.
//
// Centralized so the URL-builder pattern is uniform across BuildDeck,
// UploadDeck, StreamingDeckResult, and any future callsite that needs
// the canonical owner segment.

import { useUser } from "@clerk/clerk-react";

export function useMyUsername(): string | null {
  const { user } = useUser();
  return user?.username ?? null;
}
